import React from 'react';
import { Search, FileDown } from 'lucide-react';

const SELECT_STYLE = {
  padding: '8px 10px', border: '1px solid var(--border-default)', borderRadius: '2px',
  fontSize: '0.8125rem', background: '#fff', color: 'var(--text-secondary)', cursor: 'pointer',
};

export const LeadsFilterBar = ({ filters, onExport }) => {
  const {
    q, setQ, country, setCountry, fit, setFit,
    contactedFilter, setContactedFilter, reportOnly, setReportOnly,
    countryOptions, fitOptions,
  } = filters;

  return (
    <div className="card" style={{ padding: '0.875rem 1.25rem', marginBottom: '1rem', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
      <div style={{ position: 'relative', flex: '1 1 220px', minWidth: '200px' }}>
        <Search size={14} style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
        <input
          data-testid="leads-search-input"
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Search name or email..."
          style={{ ...SELECT_STYLE, width: '100%', paddingLeft: '32px', cursor: 'text' }}
        />
      </div>
      <select data-testid="filter-country" value={country} onChange={e => setCountry(e.target.value)} style={SELECT_STYLE}>
        <option value="all">All countries</option>
        {countryOptions.map(c => <option key={c} value={c}>{c}</option>)}
      </select>
      <select data-testid="filter-fit" value={fit} onChange={e => setFit(e.target.value)} style={SELECT_STYLE}>
        <option value="all">All fit levels</option>
        {fitOptions.map(f => <option key={f} value={f}>{f}</option>)}
      </select>
      <select data-testid="filter-contacted" value={contactedFilter} onChange={e => setContactedFilter(e.target.value)} style={SELECT_STYLE}>
        <option value="all">Contacted: all</option>
        <option value="no">Not contacted</option>
        <option value="yes">Contacted</option>
      </select>
      <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '0.8125rem', color: 'var(--text-secondary)', cursor: 'pointer' }}>
        <input data-testid="filter-report-checkbox" type="checkbox" checked={reportOnly} onChange={e => setReportOnly(e.target.checked)} />
        Report requested
      </label>
      <button data-testid="export-csv-btn" onClick={onExport} className="btn btn-sm" style={{ background: 'linear-gradient(135deg, #F67425, #BB0518)', color: '#fff', border: 'none', fontSize: '0.8125rem' }}>
        <FileDown size={14} /> Export CSV
      </button>
    </div>
  );
};
